module.exports = __webpack_public_path__ + "img/loader-new.96c333ac.gif";